import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash/get';

import { ContemporaryLandingContext } from './ContemporaryLandingContext';
import { connectContext } from '../context/helpers/connectContext';
import { ContemporaryLandingSplashHeaderModule } from './ContemporaryLandingSplashHeaderModule/ContemporaryLandingSplashHeaderModule';
import { ContemporaryLandingStyleModule } from './ContemporaryLandingStyleModule/ContemporaryLandingStyleModule';
import { ContemporaryLandingProductsModule } from './ContemporaryLandingProductsModule/ContemporaryLandingProductsModule';
import { ContemporaryLandingFeaturedModule } from './ContemporaryLandingFeaturedModule/ContemporaryLandingFeaturedModule';
import { ContemporaryLandingMakersModule } from './ContemporaryLandingMakersModule/ContemporaryLandingMakersModule';
import { ContemporaryLandingVideoModule } from './ContemporaryLandingVideoModule/ContemporaryLandingVideoModule';
import { ContemporaryLandingCategoriesModule } from './ContemporaryLandingCategoriesModule/ContemporaryLandingCategoriesModule';
import { ContemporaryLandingTextHeaderModule } from './ContemporaryLandingTextHeaderModule/ContemporaryLandingTextHeaderModule';
import { ContemporaryLandingFurnitureTileModule } from './ContemporaryLandingFurnitureTileModule/ContemporaryLandingFurnitureTileModule';

import * as tracking from 'dibs-tracking';

import styles from './ContemporaryLandingRespLayout.scss';

const moduleComponents = {
    category: (module, isMobile) => (
        <ContemporaryLandingCategoriesModule
            key={module.type}
            contemporaryLandingRow={module}
            showSwiper={isMobile}
        />
    ),
    featured: module => (
        <ContemporaryLandingFeaturedModule key={module.type} contemporaryLandingRow={module} />
    ),
    furnitureTile: module => (
        <ContemporaryLandingFurnitureTileModule key={module.type} contemporaryLandingRow={module} />
    ),
    makers: module => (
        <ContemporaryLandingMakersModule key={module.type} contemporaryLandingRow={module} />
    ),
    products: (module, isMobile) => (
        <ContemporaryLandingProductsModule
            key={module.type}
            contemporaryLandingRow={module}
            showSwiper={isMobile}
        />
    ),
    splashHeader: module => (
        <ContemporaryLandingSplashHeaderModule
            key={module.type}
            contemporaryLandingSplashHeader={module}
        />
    ),
    style: (module, isMobile) => (
        <ContemporaryLandingStyleModule
            key={module.type}
            contemporaryLandingRow={module}
            showCta={isMobile}
        />
    ),
    textHeader: (module, isMobile) => (
        <ContemporaryLandingTextHeaderModule
            key={module.type}
            contemporaryLandingHeader={module}
            showSwiper={isMobile}
        />
    ),
    video: module => (
        <ContemporaryLandingVideoModule key={module.type} contemporaryLandingVideo={module} />
    ),
};

class ContemporaryLandingRespLayoutComponent extends Component {
    componentDidMount() {
        this.fireInitialTracking();
    }

    fireInitialTracking() {
        tracking.trackPageview();
    }

    render() {
        const { isMobile, viewer } = this.props;

        const modules = get(viewer, 'contemporaryLanding.modules');

        const mods = modules.map(module => {
            const { type } = module;
            const component = moduleComponents[type];
            if (component) {
                return component(module, isMobile);
            }
            return null;
        });

        return <div className={styles.container}>{mods}</div>;
    }
}

ContemporaryLandingRespLayoutComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    userType: PropTypes.string,
};

function mapContextToProps({ isMobile, userType }) {
    return {
        isMobile,
        userType,
    };
}

const ContemporaryLandingRespLayoutWithContext = connectContext(
    ContemporaryLandingContext,
    mapContextToProps
)(ContemporaryLandingRespLayoutComponent);

export const ContemporaryLandingRespLayout = createFragmentContainer(
    ContemporaryLandingRespLayoutWithContext,
    {
        viewer: graphql`
            fragment ContemporaryLandingRespLayout_viewer on Viewer {
                contemporaryLanding(rootId: $contemporaryLandingPreviewId) {
                    modules {
                        ...ContemporaryLandingTextHeaderModule_contemporaryLandingHeader
                        ... on ContemporaryLandingHeader {
                            type
                        }
                        ...ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader
                        ... on ContemporaryLandingSplashHeader {
                            type
                        }
                        ...ContemporaryLandingStyleModule_contemporaryLandingRow
                        ...ContemporaryLandingProductsModule_contemporaryLandingRow
                        ...ContemporaryLandingFeaturedModule_contemporaryLandingRow
                        ...ContemporaryLandingMakersModule_contemporaryLandingRow
                        ...ContemporaryLandingVideoModule_contemporaryLandingVideo
                        ...ContemporaryLandingCategoriesModule_contemporaryLandingRow
                        ... on ContemporaryLandingVideo {
                            type
                        }
                        ... on ContemporaryLandingRow {
                            ...ContemporaryLandingFurnitureTileModule_contemporaryLandingRow
                            type
                        }
                    }
                }
            }
        `,
    }
);
